export default "__VITE_ASSET__3a28472f__"